var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryState } from 'src/app/story/state/story.state';
import { Observable, Subject } from 'rxjs';
import { PreviousChapter, NextChapter } from 'src/app/story/state/chapters/story.chapters.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { takeUntil } from 'rxjs/operators';
var EditChapterPaginationComponent = /** @class */ (function () {
    function EditChapterPaginationComponent(store, changeDetectorRef) {
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.ngUnsubscribe = new Subject();
    }
    EditChapterPaginationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.selectedChapterIndex$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (chapterIndex) {
            _this.chapterIndex = chapterIndex;
            _this.changeDetectorRef.markForCheck();
        });
    };
    EditChapterPaginationComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EditChapterPaginationComponent.prototype.handlePreviousClick = function () {
        this.store.dispatch(new PreviousChapter());
    };
    EditChapterPaginationComponent.prototype.handleNextClick = function () {
        this.store.dispatch(new NextChapter());
    };
    __decorate([
        Select(StoryState.getStory),
        __metadata("design:type", Observable)
    ], EditChapterPaginationComponent.prototype, "story$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], EditChapterPaginationComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterIndex),
        __metadata("design:type", Observable)
    ], EditChapterPaginationComponent.prototype, "selectedChapterIndex$", void 0);
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], EditChapterPaginationComponent.prototype, "chapters$", void 0);
    return EditChapterPaginationComponent;
}());
export { EditChapterPaginationComponent };
